export default __webpack_public_path__ + "static/media/Software-Faturacao-Bancos.a10ccb93.webp";